/**
 * GitLab Configuration Section Component
 */

import { RefreshCwIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import type { GitlabConfig } from '@/lib/queries/integrations/scm/gitlab';

export type GitlabConfigSectionProps = {
  gitlabConfigs: GitlabConfig[] | undefined;
  onRefresh: () => void;
};

export const GitlabConfigSection = ({
  gitlabConfigs,
  onRefresh,
}: GitlabConfigSectionProps): JSX.Element => (
  <div className="space-y-6">
    <div className="flex flex-row justify-between items-center">
      <div className="flex flex-row items-baseline">
        <h2 className="text-2xl font-semibold">Connected Configurations</h2>
        <Button
          variant="ghost"
          className="ml-2 h-8 w-8 p-0"
          onClick={onRefresh}
        >
          <RefreshCwIcon className="h-4 w-4" />
        </Button>
      </div>
    </div>

    {gitlabConfigs === undefined ? (
      <Skeleton className="bg-background w-full h-20" />
    ) : gitlabConfigs.length === 0 ? (
      <div className="border rounded-lg p-8 text-center text-muted-foreground">
        No GitLab configurations found. Please connect your GitLab account
        first.
      </div>
    ) : (
      <div className="space-y-4">
        {gitlabConfigs.map(config => (
          <div key={config.id} className="border rounded-lg p-4 bg-card">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="font-semibold text-lg">@{config.username}</h3>
                <p className="text-sm text-muted-foreground">
                  Instance: {config.gitlabInstanceUrl}
                </p>
                <p className="text-sm text-muted-foreground">
                  User ID: {config.userId}
                </p>
                <p className="text-sm text-muted-foreground">
                  Expires: {new Date(config.expiresAt).toLocaleDateString()}
                </p>
              </div>
              <div className="text-xs text-muted-foreground">
                Connected: {new Date(config.createdAt).toLocaleDateString()}
              </div>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);
